import cstJzInstance from "@/axios/interceptor/jz/cstJz";
import ycApiInstance from "../interceptor/jz/yecai";
import jzAdApiInstance from "../interceptor/jz/ad";
import accountSetApiInstances from "../interceptor/jz/accountSet";

const advertisementApi = "/api/Advertisement?appasid=&typeId=8010";
const advertisementClickApi = "/api/Advertisement/UpdatePCClick";

// 获取账套列表
function GetAccountSetList() {
  let appId = sessionStorage.getItem("appTypeId");
  const accountSetApiInstance = accountSetApiInstances[appId];
  return (
    accountSetApiInstance &&
    accountSetApiInstance.post("/api/SalarySlip/GetAccountSetList")
  );
}

//获取财税通的记账账套列表
function GetCstAccountSetList() {
  let id = Number(sessionStorage.getItem("cstId"));
  // return cstJzInstance.get(`MasterPages/Services/GetExternalAccountList.ashx?r=${new Date().getTime()}&externalId=${id}&userFlag=true`)
  return cstJzInstance.get(
    `Salary/Service/CstSalarySlip.ashx?cmd=GetAccountSetList&cstCompanyId=${id}`,
  );
}

// 获取有工资的月份
function SalaryMonthList(as_id) {
  if (sessionStorage.getItem("cstGzt") === "true") {
    return cstJzInstance.get(
      "/Salary/Service/CstSalarySlip.ashx?cmd=GetYearMonth&asid=" + as_id,
    );
  } else {
    let appId = sessionStorage.getItem("appTypeId");
    const accountSetApiInstance = accountSetApiInstances[appId];
    return (
      accountSetApiInstance &&
      accountSetApiInstance.post(
        "/api/SalarySlip/GetYearMonthList?asid=" + as_id,
      )
    );
  }
}
// 获取工资数据
function SalaryList(as_id, mid) {
  if (sessionStorage.getItem("cstGzt") === "true") {
    let id = Number(sessionStorage.getItem("cstId"));
    return cstJzInstance.get(
      "/Salary/Service/SalarySlip.ashx?cmd=GetSalaryList&asid=" +
        as_id +
        "&mid=" +
        mid +
        "&cstCompanyId=" +
        id,
    );
  } else {
    let appId = sessionStorage.getItem("appTypeId");
    const accountSetApiInstance = accountSetApiInstances[appId];
    return (
      accountSetApiInstance &&
      accountSetApiInstance.post(
        "/api/SalarySlip/GetSalaryList?asid=" +
          as_id +
          "&mid=" +
          mid,
      )
    );
  }
}

//获取弹窗广告
function getAdsInfo() {
  return jzAdApiInstance.get(advertisementApi);
}

//点击广告
function clickAds(adId) {
  return jzAdApiInstance.post(
    `${advertisementClickApi}?adId=${adId}&typeId=8010`,
  );
}

//获取业财的asid
function YcAsid(jz_asid) {
  return ycApiInstance.get(
    `/Settings/Services/GetAccountSetRelationScmAsId.ashx?asId=${jz_asid}`,
  );
}

export default {
  GetAccountSetList,
  SalaryMonthList,
  SalaryList,
  GetCstAccountSetList,
  getAdsInfo,
  clickAds,
  YcAsid,
};
